import type { ActionSection, ActionSectionItem } from './ActionSection';
import { ActionSectionItemAction } from './ActionSection';
import type { CustomSection, SiteSearchNotInstalledCustomSection, VeloCustomSection } from './CustomSection';
import type { MediaManagerOptions } from './MediaManagerOptions';
import type { PhotoStudioOptions } from './PhotoStudioOptions';
import type { PersonalizedSection } from './PersonalizedSection';
import type { LogoSection } from './LogoSection';
import type {
  PresetListSection,
  PresetListSectionItem,
  PresetSection,
  PresetSectionItem,
  PresetSectionItemOverride,
  StyleParam,
} from './PresetSection';
import type { AdditionalBehavior, PropsScaleProportion, Video } from './propertyTypes';
import type { RelatedApp, RelatedAppsSection, RelatedAppWeights, RelatedAppWidget } from './RelatedAppsSection';
import type { SectionBase, SectionItemBase, SectionItemOverrideBase } from './SectionBase';
import type { SectionOverride } from './SectionOverride';
import type { ThemedSection } from './ThemedSection';
import type { WelcomeSection } from './WelcomeSection';
import type { SiteMediaSection } from './SiteMediaSection';
import type { DynamicMediaSection } from './DynamicMediaSection';
import type { MyWidgetsSection } from '../MyWidget';

export type AnySection =
  | SectionBase
  | PresetSection
  | PresetListSection
  | CustomSection
  | PersonalizedSection
  | WelcomeSection
  | RelatedAppsSection
  | ThemedSection
  | DynamicMediaSection
  | SiteMediaSection
  | MyWidgetsSection
  | LogoSection
  | ActionSection;

export type AnySectionItem = ActionSectionItem | PresetSectionItem | PresetListSectionItem;

export * from './SectionFooter';

export { ActionSectionItemAction };

export type {
  SectionBase,
  SectionItemBase,
  SectionItemOverrideBase,
  SectionOverride,
  ActionSection,
  ActionSectionItem,
  PresetSection,
  PresetSectionItem,
  SiteMediaSection,
  DynamicMediaSection,
  PresetSectionItemOverride,
  PresetListSectionItem,
  PresetListSection,
  CustomSection,
  LogoSection,
  SiteSearchNotInstalledCustomSection,
  VeloCustomSection,
  PersonalizedSection,
  WelcomeSection,
  RelatedAppsSection,
  RelatedApp,
  RelatedAppWeights,
  RelatedAppWidget,
  ThemedSection,
  Video,
  AdditionalBehavior,
  PropsScaleProportion,
  MediaManagerOptions,
  PhotoStudioOptions,
  StyleParam,
};
